// src/components/common/PaginationComponent.js
import React from "react";
import { Pagination } from "react-bootstrap";

const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null; // hide if only one page

  // Logic for showing max 7 pages
  let start = Math.max(1, currentPage - 3);
  let end = Math.min(totalPages, start + 6);

  if (end - start < 6) {
    start = Math.max(1, end - 6);
  }

  const pageItems = [];
  for (let i = start; i <= end; i++) {
    pageItems.push(
      <Pagination.Item
        key={i}
        active={i === currentPage}
        onClick={() => onPageChange(i)}
      >
        {i}
      </Pagination.Item>
    );
  }

  return (
    <div className="d-flex justify-content-end mt-3">
      <Pagination>
        <Pagination.Prev
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
        />
        {pageItems}
        <Pagination.Next
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
        />
      </Pagination>
    </div>
  );
};

export default PaginationComponent;
